export const SERVER = {
    // URL: 'http://localhost:4000',

    URL: 'https://messageall.herokuapp.com',
}